// extracted by mini-css-extract-plugin
export default {"label":"CategoryOverview_label__uyN2z"};